import { i18n } from '@/plugins/i18n';
import { merchantType, merchantTypeStr } from '@/constants/merchantType';
import { stakeholderStatusStr, stakeholderVariant } from '@/constants/stakeholderStatus';
import {
    relatedMerchantType,
    relatedMerchantTypeStr,
    relatedMerchantTypeVariant
} from '@/constants/related_merchant_type';

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.full_name'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'cellphone_number',
        title: i18n.t('label.phone'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: true,
        template: (row) => {
            switch (row.type) {
                case relatedMerchantType.PF:
                    return `<span class="badge badge-primary">${relatedMerchantTypeStr.get(row.type)}</span>`;
                case relatedMerchantType.GATEWAY:
                    return `<span class="badge badge-success">${relatedMerchantTypeStr.get(row.type)}</span>`;
                case relatedMerchantType.WALLET:
                    return `<span class="badge badge-secondary">${relatedMerchantTypeStr.get(row.type)}</span>`;
            }

        },
        textAlign: 'center',
    },
    {
        field: 'merchant_type',
        title: i18n.t('label.merchant_type'),
        sortable: true,
        template: (row) => {
            if (row.merchant_type == merchantType.LEGAL) {
                return `<span>${merchantTypeStr.get(merchantType.LEGAL)}</span>`;
            }

            return `<span>${merchantTypeStr.get(merchantType.REAL)}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: true,
        template: (row) => {
            return `<span class="badge badge-${stakeholderVariant(row.status)}">${stakeholderStatusStr.get(row.status)}</span>`;
        },
        textAlign: 'center',
    },
]
